import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { FNLookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-foreign-national-picker',
  standalone: true,
  imports: [
    FormsModule,
    AutoCompleteModule,
  ],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ForeignNationalPickerComponent),
      multi: true
    }
  ]
})
export class ForeignNationalPickerComponent extends BasePickerComponent<FNLookupItem> {
  @Input() companyId: string = '';
  @Input() relativeOf: string = '';
  @Input() matterId: string = '';

  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<FNLookupItem>> {
    return this.lookupService.getForeignNationals(undefined, query, this.companyId, this.relativeOf, this.matterId, 20);
  }

  override load(keys: string[]): Observable<ListResult<any>> {
    return this.lookupService.getForeignNationals(keys);
  }
}
